<template>
<div class="site-wrapper">
    <SyncBanner />
  <headers/>

    <router-view/> 
          

</div>
</template>

<script>
// import { decode } from 'js-base64';
import headers from '@/components/headers';
// import footer from '@/components/footer';

import SyncBanner from '@/components/syncBanner.vue';


export default {
  components:{
    headers,
    SyncBanner,
    // , footer  
  },
  name: 'app',
    data() {
      return {

            // fad:decode(this.$request.ayar().genel.f),
            // isim:decode(this.$request.ayar().genel.k),
      };
  },
  created(){
    //this.active = this.$route.name
    //alert(this.$store.getLoading())
  },
  methods: {

    kapat(){
      this.$store.setloading = [false,'...']
    }
      // cikis(){
      //     this.$helper.logout();
      // },    
  }  
 
}
</script>
<style>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .van-overlay {
    z-index:19999 !important;
     background-color: rgba(0,0,0,.7)
  }
  .van-loading__text{
    font-size:33px !important;
    font-weight:normal !important
  }
</style>


// WEBPACK FOOTER //
// src/components/content.vue